module.exports = __webpack_public_path__ + "Icono_DisponibilidadATQ_512.png";